import Phaser from "phaser";
import "./styles.css";
import { createGameConfig } from "./game/config";
import { synthAudio } from "./game/systems/SynthAudio";

const game = new Phaser.Game(createGameConfig());

if (import.meta.env.DEV) {
  window.__QUINT_BROS_GAME__ = game;
}

const pauseWhenHidden = (): void => {
  if (document.hidden) {
    game.loop.sleep();
    synthAudio.setPaused(true);
  } else {
    game.loop.wake();
    synthAudio.setPaused(
      document.getElementById("game-container")?.dataset.state === "paused",
    );
  }
};

document.addEventListener("visibilitychange", pauseWhenHidden);

window.addEventListener("beforeunload", () => {
  document.removeEventListener("visibilitychange", pauseWhenHidden);
  delete window.__QUINT_BROS_GAME__;
  game.destroy(true);
});

declare global {
  interface Window {
    __QUINT_BROS_GAME__?: Phaser.Game;
  }
}
